export interface IItemList {
  text: string;
  value: number | string;
}

export const isLkkAppClient = (type: string): boolean => type === 'LKK_APP_CLIENT';
